// Convert Vuetify tableOptions to Axios query params
export default function (
  { itemsPerPage = 20, page = 1, sortBy = [{ key: 'UUID', order: 'asc' }] },
  searchString = '',
  noBrackets = false
) {
  return {
    noOfRecords: itemsPerPage,
    // For now do not allow multisort
    'orderBy[field]': noBrackets ? sortBy[0].key : `[${sortBy[0].key}]`,
    'orderBy[dir]': sortBy[0].order,
    searchString: searchString || undefined,
    pageNo: page
  };
}
